import { render, staticRenderFns } from "./AddFreeClassModal.vue?vue&type=template&id=bcc57c9a&scoped=true&"
import script from "./AddFreeClassModal.vue?vue&type=script&lang=js&"
export * from "./AddFreeClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc57c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc57c9a')) {
      api.createRecord('bcc57c9a', component.options)
    } else {
      api.reload('bcc57c9a', component.options)
    }
    module.hot.accept("./AddFreeClassModal.vue?vue&type=template&id=bcc57c9a&scoped=true&", function () {
      api.rerender('bcc57c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/AddFreeClassModal.vue"
export default component.exports